<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <!-- force render tab because need validate all tab -->
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <Tabs v-model:activeKey="menuContext.tabKey" type="card">
            <TabPane key="Requestor" :tab="$t('views.request.requestor.title')" :forceRender="true">
                <RequestorForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataTempKey="refHcTemp"
                    userAuthorizeRole="HC"
                    :isLoading="isLoading"
                ></RequestorForm>
            </TabPane>
            <TabPane key="HcInfo" :tab="$t('views.request.hcInfo.title')" :forceRender="true">
                <HcInfoForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refHcTemp"
                    :request="data.useForm.modelRef"
                    :isLoading="isLoading"
                ></HcInfoForm>
            </TabPane>
            <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                <AttachmentForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refHcTemp"
                    :isLoading="isLoading"
                ></AttachmentForm>
            </TabPane>
            <TabPane key="Remark" v-if='data.userInfo?.refDepartment' :tab="$t('views.remark.text')" :forceRender="true">
                <RemarkInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoading="isLoading"
                ></RemarkInfoForm>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
import { Card, Form, Tabs } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../../app.logic";
import { createFormTitle, initForm, initState, isLoading, onClickModalOk } from "./request.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        Tabs,
        TabPane: Tabs.TabPane,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
        RequestorForm: defineAsyncComponent(() => import("../../storage-location/request/requestor/RequestorForm")),
        HcInfoForm: defineAsyncComponent(() => import("./hc-info/HcInfoForm")),
        AttachmentForm: defineAsyncComponent(() => import("../../storage-location/request/attachment/AttachmentForm")),
        RemarkInfoForm: defineAsyncComponent(() => import("../../remark/RemarkInfoForm")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "hc-requests" },
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true },
        forceDefault: { default: false }
    },
    setup(props) {
        // eslint-disable-next-line vue/no-mutating-props
        //props.menuContext.tabKey = "HcInfo";
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const state = reactive(initState({ props }));
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [], sendReceive: false });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, state, route });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading,
            callOnClickModalOk
        };
    }
});
</script>
